import React from 'react';
import {vars, style, classes} from './doppe-action-type-widget-auto-size-image-view.st.css';
import {evaluateFunction, HtmlObjectResizeMode} from "@wix/devzai-utils-common";
import {
    WixImageResource,
    wixImageResourceGetOriginalImageSize,
    wixImageResourceGetResizedImageUrl
} from "@wix/devzai-common-wix";
import {
    ImageView,
    ImageViewPositionHorizontal,
    ImageViewPositionVertical,
    RatioMaintainer
} from "@wix/devzai-utils-react";

export const DoppeActionTypeWidgetAutoSizeImageView = React.memo(function DoppeActionTypeWidgetAutoSizeImageView (props: DoppeActionTypeWidgetAutoSizeImageView.Props) {
    const {
        imageResource,
        maxImageHeight = 217,

        style: styleProp,
        className,
        ...htmlAttributes
    } = props;

    return (
        <RatioMaintainer
            {...htmlAttributes}
            className={style(classes.root, className)}
            widthHeightRatio={evaluateFunction(() => {
                const originalImageSize = wixImageResourceGetOriginalImageSize(imageResource);

                return originalImageSize ? originalImageSize.width / originalImageSize.height : false;
            })}
            style={{
                ...styleProp,
                [vars.maxImageHeight]: `${maxImageHeight}px`
            }}
        >
            <div
                className={style(classes.imageViewContainer, {})}
            >
                <ImageView
                    className={style(classes.imageView, {})}
                    positionHorizontal={ImageViewPositionHorizontal.Center}
                    positionVertical={ImageViewPositionVertical.Center}
                    src={wixImageResourceGetResizedImageUrl(imageResource, {
                        resizeMode: HtmlObjectResizeMode.ScaleDown,
                        targetHeight: maxImageHeight
                    })}
                />
            </div>
        </RatioMaintainer>
    );
});

export namespace DoppeActionTypeWidgetAutoSizeImageView {

    export interface Props extends React.HTMLAttributes<any> {
        imageResource: WixImageResource;
        maxImageHeight?: number;
    }
}
